var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12479_14294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4266 11.175C10.5481 10.089 9.33589 9.41602 7.99919 9.41602C7.36241 9.41536 6.73181 9.57042 6.14362 9.87229C5.55543 10.1742 5.02125 10.6169 4.57177 11.175L5.71452 12.589C6.29963 11.865 7.10779 11.416 7.99919 11.416C8.89059 11.416 9.69876 11.865 10.2839 12.589L11.4266 11.175Z",
    fill: "#2E1A47",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99919 5.41602C5.84059 5.41602 3.81129 6.45602 2.28468 8.34502L3.42742 9.75902C4.64855 8.24802 6.27215 7.41602 7.99919 7.41602C9.72624 7.41602 11.3498 8.24802 12.571 9.75902L13.7137 8.34502C12.1871 6.45602 10.1578 5.41602 7.99919 5.41602Z",
    fill: "#2E1A47",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.51702C14.9688 4.23941 13.7476 3.22069 12.4037 2.51702H12.4053C11.0096 1.78603 9.52823 1.41603 8.00081 1.41603C6.51464 1.41384 5.04276 1.77501 3.66973 2.47879C2.29671 3.18257 1.04958 4.21508 0 5.51702L1.14274 6.93102C2.97404 4.66402 5.40984 3.41602 8 3.41602C10.5902 3.41602 13.0252 4.66502 14.8573 6.93102L16 5.51702Z",
    fill: "#2E1A47",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 13.5,
    r: 1,
    fill: "#2E1A47",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12479_14294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.4dc7ac9284ddde1969c3902294ea26a2.svg";
export { ForwardRef as ReactComponent };